import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { ClientDiscoveryWorkroom } from './index'

/**
 * V2 Customer Discovery Workroom — route wrapper.
 *
 * Registered standalone + auth-gated (see router.tsx):
 *   /square/command-center/intake      (primary)
 *   /square/command-center/discovery   (alias → redirect)
 *
 * Opened by the "Discovery" nav button on the V2 command center.
 *
 * Honesty contract (PHASE_2M P9 — wired): the workroom loads invites and
 * submissions from the REAL intake backend (sq_intake_invites +
 * sq_support_requests via /api/square/command-center/intake-invites*).
 * Create / revoke / decide / convert-to-project are live, audited calls;
 * convert navigation flows through onNavigate. Still honestly deferred in
 * place: email/SMS delivery (manual copy/share), workspace push-updates,
 * portal open/copy telemetry, private-notes persistence, file storage.
 * The production intake surface stays at /square/command-center/
 * client-intake and the public receiver at /square/intake/:code.
 */
export default function SquareCodeDiscoveryRoute() {
  const navigate = useNavigate()
  return (
    <ClientDiscoveryWorkroom
      onExit={() => navigate(COMMAND_CENTER_ROOT)}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onNavigate={(path: string) => navigate(path)}
    />
  )
}
